/* eslint-disable @typescript-eslint/no-explicit-any */
import { createPortal } from 'react-dom'
import { DragOverlay } from '@dnd-kit/core'
import { Table } from '@tanstack/react-table'
import { DataTableRow } from './DataTableBody'

interface TableDragOverlayProps<TData> {
  activeId: string | null
  table: Table<TData>
  computedColWidths: Record<string, number>
  frozenColOffsetsById: Record<string, number>
  leafColumns: any[]
  frozenColumnCount: number
  compactMode: boolean
  isRegrouping: boolean
  cellMeasureRefs?: any
}

export function TableDragOverlay<TData>({
  activeId,
  table,
  computedColWidths,
  frozenColOffsetsById,
  leafColumns,
  frozenColumnCount,
  compactMode,
  isRegrouping,
  cellMeasureRefs,
}: TableDragOverlayProps<TData>) {
  const activeRow =
    activeId &&
    table.getRowModel().rows.find((r) => {
      const rowData = r.original as Record<string, unknown>
      return String(rowData?.id || r.id) === activeId
    })

  if (!activeRow) return null

  return createPortal(
    <DragOverlay>
      <div style={{ width: table.getTotalSize() }}>
        <table className="bg-offwhite w-full table-fixed caption-bottom border-separate border-spacing-0 overflow-hidden rounded-l-full rounded-r-full text-sm opacity-70 shadow-lg">
          <colgroup>
            {table.getAllLeafColumns().map((column) => (
              <col
                key={column.id}
                style={{
                  minWidth: computedColWidths[column.id] ? `${computedColWidths[column.id]}px` : undefined,
                  width: column.columnDef.size ? `${column.columnDef.size}px` : undefined,
                }}
              />
            ))}
          </colgroup>
          <tbody className="bg-offwhite">
            <DataTableRow
              row={activeRow}
              frozenColOffsetsById={frozenColOffsetsById}
              leafColumns={leafColumns}
              freezePane={frozenColumnCount}
              compactMode={compactMode}
              cellMeasureRefs={cellMeasureRefs}
              isRegrouping={isRegrouping}
              isOverlay
            />
          </tbody>
        </table>
      </div>
    </DragOverlay>,
    document.body
  )
}
